import React from 'react'
import PropType from 'prop-types'
import request from 'superagent'
import moment from 'moment'

import get from '~/utils/paginated.js'

import Delivery from './delivery.jsx'
import Error from '~/webhooks/components/error.jsx'

const Deliveries = (props) => {
  const { deliveries, isExpanded, onExpand, ...rest } = props
  if (deliveries.length === 0) {
    return (
      <div className="webhook-event__deliveries-empty">
        There are no deliveries ☹️
      </div>
    )
  }

  if (isExpanded) {
    return deliveries.map((delivery, index) => {
      return (
        <Delivery
          key={delivery.id}
          id={delivery.id}
          attributes={delivery.attributes}
          {...rest}
        />
      )
    })
  }

  const delivery = deliveries[0]
  return (
    <>
      <Delivery
        key={delivery.id}
        id={delivery.id}
        attributes={delivery.attributes}
        {...rest}
      />

      {deliveries.length > 1 ? (
        <button
          className="tds-btn tds-btn--interaction as-fs"
          onClick={onExpand}
        >
          Show more deliveries
        </button>
      ) : null}
    </>
  )
}

export default class Event extends React.Component {
  state = {
    error: null,
    deliveries: [],
    isExpanded: false,
  }

  static propTypes = {
    id: PropType.string.isRequired,
    event: PropType.object.isRequired,
    subscriptionId: PropType.string.isRequired,
  }

  componentDidMount() {
    this._fetch()
  }

  _fetch = () => {
    const { subscriptionId, id } = this.props
    this.setState({ deliveries: [] })
    get(
      `/webhooks/v2/subscriptions/${subscriptionId}/events/${id}/deliveries?order=-created_at`,
      (subset) => {
        this.setState({ deliveries: this.state.deliveries.concat(subset) })
      }
    ).catch((error) => {
      this.setState({ error: error.message })
    })
  }

  _redeliver = () => {
    const { subscriptionId, id } = this.props
    const url = `/webhooks/v2/subscriptions/${subscriptionId}/events/${id}/redeliver`
    request
      .post(url)
      .set('X-CSRF-Token', $.rails.csrfToken())
      .then(() => {
        setTimeout(this._fetch, 1000)
      })
      .catch((error) => {
        console.error(error)
      })
  }

  render() {
    return (
      <Error message={this.state.error} className="pane__body webhook-event">
        <div className="webhook-event__header">
          <code className="badge badge--neutral-subtle">
            {this.props.event.uuid}
          </code>

          <code className="webhook-event__timestamp">
            {moment(this.props.event.created_at).format(
              'YYYY-MM-DD kk:mm:ss Z'
            )}
          </code>

          <button
            className="tds-btn tds-btn--sm tds-btn--interaction"
            onClick={this._redeliver}
          >
            Redeliver
          </button>
        </div>

        <div className="webhook-event__deliveries">
          <Deliveries
            deliveries={this.state.deliveries}
            isExpanded={this.state.isExpanded}
            onExpand={() => {
              this.setState({ isExpanded: true })
            }}
          />
        </div>
      </Error>
    )
  }
}
